export default __webpack_public_path__ + "static/media/BackgroundYono.01c73792.png";